





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import User from "@/models/user";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("authentication", ["user"]),
  },
})
export default class PageNotFound extends Vue {
  user!: User;
}
